<script>
  import { ChevronRightIcon } from "svelte-feather-icons";
  import { useNavigate } from "svelte-navigator";
  import { intervalToDuration, formatDuration, parseISO } from "date-fns";

  export let flight;

  const navigate = useNavigate();

  function getDuration(flight) {
    try {
      return formatDuration(
        intervalToDuration({
          start: parseISO(flight.startedTime),
          end: parseISO(flight.endedTime),
        })
      );
    } catch (E) {
      return "N/A";
    }
  }
</script>

<div class="flight-entry" on:click={() => navigate("/flights/" + flight.id)}>
  <div class="mainInfo">
    <div class="flightInfo">
      <div class="flightName">{flight.name}</div>
      <div>ID <span>{flight.id}</span></div>
    </div>
    <div class={"status " + flight.state.toLowerCase()}>
      {flight.state}
    </div>
    <ChevronRightIcon />
  </div>
  {#if flight.state == "ENDED"}
    <div class="details">
      <div>
        Started: <span>{new Date(flight.startedTime).toLocaleString()}</span>
      </div>
      <div>
        Duration: <span data-field="duration">{getDuration(flight)}</span>
      </div>
    </div>
  {/if}
</div>

<style>
  .flight-entry {
    cursor: pointer;
  }
  .flight-entry {
    color: white;
    background: black;
    padding: 1rem;
    margin-bottom: 1rem;
  }
  .flight-entry .mainInfo {
    flex: 0 0;
    display: grid;
    align-items: center;
    grid-template-columns: minmax(0, 1fr) auto auto;
  }
  .flightName {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .flight-entry .flightInfo {
    flex: 1;
    padding-right: 20px;
  }

  .flight-entry .flightInfo div:nth-child(2) {
    color: gray;
  }

  .flight-entry .details {
    margin-top: 8px;
    color: lightgrey;
  }
</style>
